module.exports = __webpack_public_path__ + "media/images/img_top_menu_2-2435e4ac3e9f5349c600fadce32dbc35.png";